import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MasterParkingDevice } from '../Models/master-device';
import { MasterParkingDeviceAction } from '../Models/master-device-action';
import { MasterFastagReconciliation } from '../Models/master-fastag-reconciliation';
import { CoreServiceService } from '../core/core-service.service';
import { Status } from '../Models/status';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {

  private BaseApiPath: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {
    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;
  }
  public getDevices(): Observable<MasterParkingDevice[]> {
    const ApiUrl = this.BaseApiPath + 'device/getdevices';
    return this.http.get<MasterParkingDevice[]>(ApiUrl);
  }
  public GetSingleDevice(masterParkingDevice: MasterParkingDevice): Observable<MasterParkingDevice> {
    const ApiUrl = this.BaseApiPath + 'device/GetDevice';
    return this.http.post<MasterParkingDevice>(ApiUrl, masterParkingDevice);
  }
  public InsertUpdateDevice(masterParkingDevice: MasterParkingDevice): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'device/InsertUpdateDevice';
    return this.http.post<Status<string>>(ApiUrl, masterParkingDevice);
  }
  public InsertUpdateDeviceAction(masterParkingDeviceAction: MasterParkingDeviceAction): Observable<Status<string>> {
    const ApiUrl = this.BaseApiPath + 'device/InsertUpdateDeviceAction';
    return this.http.post<Status<string>>(ApiUrl, masterParkingDeviceAction);
  }
  public AddDeviceCommand(masterParkingDeviceAction: MasterParkingDeviceAction): Observable<MasterParkingDeviceAction> {
    const ApiUrl = this.BaseApiPath + 'device/AddDeviceCommand';
    return this.http.post<MasterParkingDeviceAction>(ApiUrl, masterParkingDeviceAction);
  }
  public KnockOff(masterFastagReconciliation: MasterFastagReconciliation): Observable<MasterFastagReconciliation> {
    const ApiUrl = this.BaseApiPath + 'device/KnockOff';
    return this.http.post<MasterFastagReconciliation>(ApiUrl, masterFastagReconciliation);
  }

}
